import {
  ArrayMaxSize,
  ArrayMinSize,
  IsArray,
  IsBoolean,
  IsDateString,
  IsIn,
  IsInt,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Min,
} from 'class-validator';
import { MEASUREMENT_UNITS } from '../../label/measurement-unit';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';
import { TRANSPORT_MODES, type TransportModeValue } from './create-transport-document.dto';

export class BulkCreateTransportDocumentsDto {
  @IsUUID()
  @IsNotEmpty()
  lotId!: string;

  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(200)
  @IsUUID(undefined, { each: true })
  customerIds!: string[];

  @IsString()
  @IsNotEmpty()
  causale!: string;

  @IsIn(TRANSPORT_MODES)
  transportMode!: TransportModeValue;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  carrierName?: string;

  @IsDateString()
  @IsNotEmpty()
  transportStartedAt!: string;

  @IsInt()
  @IsOptional()
  @Min(1)
  packagesCount?: number;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  goodsAppearance?: string;

  @IsNumber()
  @Min(0.001)
  quantity!: number;

  @IsIn(MEASUREMENT_UNITS)
  @IsOptional()
  @OptionalStringTransform()
  unit?: string;

  @IsBoolean()
  issueImmediately!: boolean;
}
